import React from 'react'
import styles from "./datePicker.module.css"
import { generateDate } from '../../../../utils/calendar'


const DateSection = (props) => {


    const MonthNames = ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"]
    const DayNames = [{id:1,name:"P"},{id:2,name:"A"},{id:3,name:"T"},{id:4,name:"K"},{id:5,name:"P"},{id:6,name:"Š"},{id:0,name:"S"}]
    const currentMonth = MonthNames[generateDate()[0].date.month()];

    const calendarArray = []

    const formatingArray = () => {
        const weeksPerRow = []
        for(let i = 0; i < props.weeksPerRow; i++)weeksPerRow.push(...DayNames) // responsiveness
        calendarArray.push([...weeksPerRow])
        let row = []
        let indicator = 0
        let next = 0

        while(next < generateDate().length){
            const month_day_weekday_no = generateDate()[next].date.day()
            const calendarDayObj = DayNames.filter(day_obj => day_obj.id === month_day_weekday_no)[0]
            if(calendarArray[0][indicator] === calendarDayObj){
                row.push(next)
                next++
            }
            else{
                row.push(-1)
            }
            indicator++
            if(indicator === calendarArray[0].length){
                calendarArray.push(row)
                row = []
                indicator = 0
            }            
        }
        calendarArray.push(row)

        return calendarArray
    }

    formatingArray()

    
    return (

        <div className={styles.wrapper}>
            <h2>{currentMonth}</h2>

            {
                calendarArray.map((row,index) => {  
                    
                    return <div key={index} className={styles.box_row}>
                        {
                            row.map((element,index) => {
                                const DateObj = generateDate()[element]

                                const text = element !== -1 && (element.name || DateObj.date.date())
                                const prev_day_styles = (DateObj && props.todays_day > DateObj.date.date()) && styles.prev_day
                                const header_styles = element.name && (element.id === 0 || element.id === 6)
                                const weekend_styles = DateObj &&(!DateObj.date.day() || DateObj.date.day() === 6)
                                const isHovered = !element.name && !prev_day_styles && text && styles.hovered
                                const isActive = props.selected === text && styles.active

                                const formatedDate = !element.name && !prev_day_styles && element !== -1 && (element.name || DateObj.date.format('DD/MM/YYYY'))
                                
                                return <div key={index} onClick={props.onSelect.bind(null,text,formatedDate)} className={`
                                    ${styles.box} 
                                    ${weekend_styles && styles.weekend} 
                                    ${header_styles && styles.box_header}
                                    ${prev_day_styles}
                                    ${isHovered}
                                    ${isActive}
                                    `}
                                >
                                    <h3>{(text) || null}</h3>
                                </div>
                            })
                        }
                    </div>
                })
            }
            
        </div>
  )
}

export default DateSection